import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Sparkles, X } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// A one-time, dismissible nudge for members who were licensed BEFORE the interest
// picker shipped (and haven't opted out or set interests yet).
export const InterestBanner = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    let dismissed = null, onboarded = null;
    try {
      dismissed = localStorage.getItem("tr_interest_banner_dismissed");
      onboarded = localStorage.getItem("tr_interests_onboarded");
    } catch (e) { /* ignore */ }
    if (!user?.has_license || dismissed || onboarded) return;
    api.get("/ads/interests")
      .then((r) => { if (!r.data.opt_out && (r.data.explicit || []).length === 0) setShow(true); })
      .catch(() => {});
  }, [user]);

  const dismiss = () => {
    try { localStorage.setItem("tr_interest_banner_dismissed", "1"); } catch (e) { /* ignore */ }
    setShow(false);
  };

  if (!show) return null;
  return (
    <div data-testid="interest-banner" className="flex items-center gap-3 bg-race-volt/10 border border-race-volt/40 rounded-md px-4 py-3 mb-5">
      <Sparkles size={18} className="text-race-volt shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-race-txt">Make your sponsors fit you</p>
        <p className="text-xs text-race-sub">Pick a few interests and we'll show ads you actually care about. Takes 10 seconds.</p>
      </div>
      <button onClick={() => navigate(`/onboarding/interests?next=${encodeURIComponent(loc.pathname)}`)}
        data-testid="interest-banner-cta"
        className="text-xs font-semibold bg-race-volt text-race-bg rounded-sm px-3 py-1.5 shrink-0">Pick interests</button>
      <button onClick={dismiss} data-testid="interest-banner-dismiss" className="text-race-sub hover:text-race-txt shrink-0"><X size={16} /></button>
    </div>
  );
};

export default InterestBanner;
